import { useState } from "react";
import Utils from "../../utils/Utils";

const customSort = (a, b) => {
  if (a === "" || a === null) return 1;
  if (b === "" || b === null) return -1;
  if (a === b) return 0;
  return a < b ? -1 : 1;
};

const useDynamicSort = ({ tableData = [], placeEmptyRecordsAtBottom = false }) => {
  const [sortOrder, setSortOrder] = useState("asc");
  const [sortedKey, setSortedKey] = useState("");

  const sort = (key = "") => {
    if (tableData.length > 0 && typeof key === "string") {
      if (placeEmptyRecordsAtBottom) {
        const emptyValues = [...tableData].filter((item) => {
          if (!item[key]) {
            return true;
          } else {
            return false;
          }
        });

        const nonEmptyValues = [...tableData].filter((item) => {
          if (!item[key]) {
            return false;
          } else {
            return true;
          }
        });

        if (sortOrder === "asc") {
          setSortOrder("desc");
          setSortedKey(key);
          return [...[...nonEmptyValues].sort(Utils.dynamicsort(key, "asc")), ...emptyValues];
        } else {
          setSortOrder("asc");
          setSortedKey(key);
          return [...[...tableData.sort(Utils.dynamicsort(key, "desc"))], ...emptyValues];
        }
      } else {
        if (sortOrder === "asc") {
          setSortOrder("desc");
          setSortedKey(key);
          return tableData.sort(Utils.dynamicsort(key, "asc"));
        } else {
          setSortOrder("asc");
          setSortedKey(key);
          return tableData.sort(Utils.dynamicsort(key, "desc"));
        }
      }
    }
  };

  return [sortOrder, sortedKey, sort];
};

export default useDynamicSort;
